<template>
  <div>
    <div class="lab-card dea-border-grey-medium-light" :class="disabledClass">
      <template v-if="!lab.seats_available">
        <ErrorMessage :is-icon-visible="false">{{ noSeatsAvailableErrorMessage }}</ErrorMessage>
      </template>
      <template v-else-if="isLabAlreadySelected && !voidLabsChecked">
        <ErrorMessage>{{ selectedLabErrorMessage }}</ErrorMessage>
      </template>
      <div class="lab-card__data-container">
        <RadioButton
          :id="`lab-${lab.id}`"
          :name="`lab-${session.id}`"
          :checked="isLabCurrent"
          :disabled="isLabAlreadySelected || !lab.seats_available"
          @click="selectLab"
        ></RadioButton>
        <div class="dea-heading--medium__s">{{ lab.title }}</div>
        <div v-if="lab.targets" class="lab-card__grade dea-heading--medium__xm">{{ targets_list }}</div>
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p class="lab-card__description dea-text--left" v-html="lab.description"></p>
      <p v-if="lab.speakers_list" class="dea-text--left">
        <span class="lab-card__authors dea-heading--medium__s">{{ lab.speakers_list }}</span>
      </p>
      <p v-if="lab.warning" class="lab-card__prerequisite dea-text--right dea-heading--regular__xs">
        {{ lab.warning }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorMessage from "@/components/elements/ErrorMessage";
import RadioButton from "@/components/elements/RadioButton";

export default {
  name: "LabCard",
  components: { ErrorMessage, RadioButton },
  props: {
    session: {
      type: Object,
      default: () => {
        return {};
      },
    },
    lab: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectLabAction: {
      type: Function,
      default: () => {},
    },
    selectedLabErrorMessage: {
      type: String,
      default: "Hai già scelto questo laboratorio in un'altra sessione!",
    },
    noSeatsAvailableErrorMessage: {
      type: String,
      default: "Non ci sono più posti disponibili per questo laboratorio",
    },
  },
  computed: {
    ...mapGetters(["selectedLabs", "registrations", "voidLabsChecked"]),
    isLabAlreadySelected() {
      // this is a very rude way to remove the current session for the selectedLabs object
      if (this.selectedLabs && !this.lab.empty) {
        const newObj = { ...this.selectedLabs };
        delete newObj[this.session.id];
        // this.setIdLabForCurrentRegistration({sessionId: this.session.id, labId: this.lab.id})
        return Object.values(newObj).indexOf(this.lab.id) > -1;
      }
      return false;
    },
    isLabCurrent() {
      return this.session.selected_lab && this.session.selected_lab.id === this.lab.id;
    },
    disabledClass() {
      return {
        "lab-card--disabled": this.availableSeats === 0,
      };
    },
    targets_list() {
      return this.lab.targets.map(item => item.name).join(", ");
    },
  },
  methods: {
    // ...mapMutations(["setIdLabForCurrentRegistration"]),
    selectLab() {
      // when a lab is selected we both calls the mapped action *and* emit the click to let container
      // do its stuff
      this.selectLabAction({ session: this.session.id, lab: this.lab });
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.lab-card {
  border-bottom: $border-light;
  margin-left: $space-x-small;
  margin-top: $space-small;
  padding-left: $space-x-small;

  &--disabled {
    opacity: $opacity-medium;
    pointer-events: none;
  }

  &__data-container {
    align-items: center;
    display: flex;
  }

  &__grade {
    font-family: $font-primary-light;
    margin-left: auto;
  }

  .dea-checkbox {
    padding-bottom: 0;
    padding-top: 0;
  }

  &__description {
    line-height: $space-small;
    margin-left: $space-base;
  }

  &__authors {
    margin-left: $space-base;
  }

  &__prerequisite {
    color: $dea-color-target-magenta-formazione;
  }
}
</style>
